export const DATE_FORMATS = {
    0: 'DD/MM/YYYY',
    1: 'MM/DD/YYYY'
}

